import { useState } from 'react';
import { HistoricalValuesFormValues } from './ManualHistoricalValuesForm';

export interface HistoricalValuesFormState {
  values: HistoricalValuesFormValues;
  isValid: boolean;
}

const useHistoricalValuesForm = () => {
  const initialState = {
    values: {
      HistoricalValues: [],
      DidHistoricalChange: true,
    },
    isValid: false,
  };

  const [historicalValuesForm, setHistoricalValuesForm] =
    useState<HistoricalValuesFormState>(initialState);

  const updateHistoricalValuesForm = (state: HistoricalValuesFormState) => {
    setHistoricalValuesForm(state);
  };

  const resetHistoricalValuesForm = () => {
    updateHistoricalValuesForm(initialState);
  };

  return {
    resetHistoricalValuesForm,
    historicalValuesForm,
    updateHistoricalValuesForm,
  };
};

export default useHistoricalValuesForm;
